/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
==========================================================================================*/


import auth from '@/auth/authService'
// import firebase from 'firebase/app'
// import 'firebase/auth'

export default {
  isUserLoggedIn: () => {
    let isAuthenticated = false

    if (auth.isAuthenticated()) isAuthenticated = true
    else isAuthenticated = false
    // const firebaseCurrentUser = firebase.auth().currentUser
    // if (auth.isAuthenticated() || firebaseCurrentUser) isAuthenticated = true
    // else isAuthenticated = false

    return localStorage.getItem('userInfo') && isAuthenticated
  }
}
